import {
  Drawer, Form, Button, Col, Row, Input, Select, DatePicker, Icon
} from 'antd';
import anger from '../../images/emoticons/anger.png'
import boredom from '../../images/emoticons/boredom.png'
import excitement from '../../images/emoticons/excitement.png'
import fascination from '../../images/emoticons/fascination.png'
import joy from '../../images/emoticons/joy.png'
import love from '../../images/emoticons/love.png'
import sad from '../../images/emoticons/sad.png'
import worry from '../../images/emoticons/worry.png'

import React from 'react';
import { translate } from 'react-i18next';
import { compose } from 'redux';
const Option = Select.Option;

class DrawerFilter extends React.Component {

  constructor() {
    super();
    this.state = {
      name: '',
      reaction: '',
      type: '',
      stage: ''
    }
  }

  setFilter = (type, value) => {
    this.props.setFilter(type, value)
  }

  resetFilters = () => {
    this.setState({
      name: '',
      reaction: '',
      type: '',
      stage: ''
    })
    this.props.resetFilters()
  }


  render() {

    let { name, reaction, type, stage } = this.props.filters
    return (
      <div>
        <Drawer
          width={430}
          onClose={this.props.close}
          visible={this.props.visible}
          className="serviceTracker drawerFilter"
        >
          <h1 style={{fontSize: 24, fontWeight: 'bold', marginTop: 115}}>Search filter</h1>
          <Form layout="vertical" hideRequiredMark>
            <Row style={{marginLeft: 10}} >
              <Col span={24}>
                <Form.Item label="Name">
                  <Input value={name} onChange={(e) => this.setFilter('name', e.target.value)} placeholder="Please type student name here" />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item label="Experience reaction">
                  <Select style={{borderRadius: 20}} value={reaction} onChange={(value) => this.setFilter('reaction', value)} placeholder="Please select a experience reaction">
                    <Option value="Joy"><img style={{width: 20, marginLeft: 10}} src={joy} /> Joy</Option>
                    <Option value="Love"><img style={{width: 20, marginLeft: 10}} src={love} /> Love</Option>
                    <Option value="Worry"><img style={{width: 20, marginLeft: 10}} src={worry} /> Worry</Option>
                    <Option value="Anger"><img style={{width: 20, marginLeft: 10}} src={anger} /> Anger</Option>
                    <Option value="Excitement"><img style={{width: 20, marginLeft: 10}} src={excitement} /> Excitement</Option>
                    <Option value="Boredom"><img style={{width: 20, marginLeft: 10}} src={boredom} /> Boredom</Option>
                    <Option value="Fascination"><img style={{width: 20, marginLeft: 10}} src={fascination} /> Fascination</Option>
                    <Option value="Sad"><img style={{width: 20, marginLeft: 10}} src={sad} /> Sad</Option>
                  </Select>
                </Form.Item>
              </Col>

              <Col span={24}>
                <Form.Item label="Type of Project">
                  <Select value={type} onChange={(value) => this.setFilter('type', value)} placeholder="Please select a type of project">
                    <Option value="Direct Service">Direct Service</Option>
                    <Option value="Indirect Service">Indirect Service</Option>
                    <Option value="Advocacy">Advocacy</Option>
                    <Option value="Research">Research</Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item label="Project stage">
                  <Select value={stage} onChange={(value) => this.setFilter('stage', value)} placeholder="Please select a project stage">
                    <Option value="Investigation">Investigation</Option>
                    <Option value="Preparation">Preparation</Option>
                    <Option value="Actions">Actions</Option>
                    <Option value="Demonstration">Demonstration</Option>
                    <Option value="Reflection">Reflection</Option>
                  </Select>
                </Form.Item>
              </Col>
            </Row>
          </Form>
          <Button onClick={this.props.submit} style={styles.applyBtn}>
            Submit
            </Button>
          <div
            style={{
              left: 0,
              bottom: 0,
              width: '100%',
              display: 'flex',
              justifyContent: 'space-between',
              marginLeft: 10
            }}
          >
            <Button onClick={this.props.close} style={styles.cancelBtn}>
              Cancel
            </Button>
            <Button onClick={this.resetFilters} style={styles.cancelBtn}>
              Reset
            </Button>
          </div>
        </Drawer>
      </div>
    );
  }
}

const enhancer = compose(
  translate(['view', 'nav'], { wait: true }),
)
export default enhancer(Form.create()(DrawerFilter));


const modal = {
  position: 'absolute',
  right: '60px'
}

const styles = {
  cancelBtn: {
    width: '48%',
    borderRadius: '20px',
    border: '1px solid #899DAF',
    height: 35,
    color: '#899DAF'
  },
  applyBtn: {
    width: '100%',
    borderRadius: '20px',
    border: '1px solid #4A90E2',
    height: 35,
    color: 'white',
    backgroundColor: '#4A90E2',
    marginLeft: 10,
    marginBottom: 20
  },

}



// WEBPACK FOOTER //
// ./src/components/DrawerFilter/index.jsx